module.exports = __webpack_public_path__ + "assets/img/n_favs.840cc405.svg";